"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IN_STOCK = exports.OUT_OF_STOCK = void 0;
exports.OUT_OF_STOCK = "OUT-OF-STOCK";
exports.IN_STOCK = "AVAILABLE";
